import React, { Component } from 'react'

import PropTypes from 'prop-types'

import { GET_DEFAULT_LOG_SETTINGS, checkVideoPlayerTabIndex } from './helper'
import { Wrapper } from './component.styles'

const noop = () => {}
const AMP_LOAD_DELAY_BETWEEN_MS = 1000
let currentAmpLoadDelayMs = 0
let loadPlayerDelay
let playerPromiseResolve

export default class Video extends Component {
  static propTypes = {
    appInsightInstance: PropTypes.func,
    onEnded: PropTypes.func,
    onPlay: PropTypes.func,
    onSourceSet: PropTypes.func,
    onStopped: PropTypes.func,
    poster: PropTypes.string,
    settings: PropTypes.shape({
      autoplay: PropTypes.bool,
      controls: PropTypes.bool,
      height: PropTypes.string,
      width: PropTypes.string,
    }),
    tracks: PropTypes.array,
    videoUrl: PropTypes.string,
  }
  static defaultProps = {
    settings: {
      autoplay: false,
      controls: true,
      height: '100%',
      logo: { enabled: false },
      width: '100%',
    },
    hasVideo: false,
    tracks: [],
    onEnded: noop,
    onPlay: noop,
    onStopped: noop,
    onSourceSet: noop,
  }

  constructor() {
    super()
    this.videoRef = React.createRef()
    this.state = {
      videoUrl: undefined,
    }
  }

  componentDidMount = () => this.initializePlayer(window.amp)

  componentWillUnmount = () => {
    if (this.player) {
      this.player.dispose()
    }
    if (loadPlayerDelay) {
      clearTimeout(loadPlayerDelay)
    }
    if (playerPromiseResolve) {
      playerPromiseResolve()
    }
    if (currentAmpLoadDelayMs >= AMP_LOAD_DELAY_BETWEEN_MS) {
      currentAmpLoadDelayMs -= AMP_LOAD_DELAY_BETWEEN_MS
    }
  }

  // wait to update until Azure Media Player is initialized
  shouldComponentUpdate(nextProps, nextState) {
    return !!this.player
  }

  /*
   * NOTE: this function is deprecated by React
   * not worth fixing since this component
   * is replaced by VideoV2 (./updatedComponent.jsx)
   */
  componentWillReceiveProps(newProps) {
    const { videoUrl } = newProps
    if (videoUrl) {
      this.setState({
        videoUrl: videoUrl,
      })
    }
  }

  componentDidUpdate(prevProps) {
    const { videoUrl, tracks, settings } = this.props

    if (prevProps.videoUrl !== this.state.videoUrl) {
      if (
        settings.plugins?.cfcInteractiveVideo?.vtt &&
        this.player.cfcInteractiveVideo
      ) {
        this.player.cfcInteractiveVideo({
          vtt: settings.plugins.cfcInteractiveVideo.vtt,
        })
      }
      this.player.src({ src: this.state.videoUrl || videoUrl }, tracks)
    }
    checkVideoPlayerTabIndex()
  }

  initializePlayer = async () => {
    const {
      appInsightInstance,
      videoUrl,
      tracks,
      settings,
      poster,
      onStopped,
      onEnded,
      onPlay,
      dataTestId,
      logger,
      onSourceSet,
    } = this.props || {}

    if (!amp) {
      return
    }
    const defaultLogSettings = GET_DEFAULT_LOG_SETTINGS()
    if (appInsightInstance && amp) {
      logger.loadAppInsightsPlugin(
        appInsightInstance,
        amp,
        settings?.plugins?.appInsights || defaultLogSettings,
      )
    }
    // ensure that each Azure Media Player instance has time to load independently
    // see: https://stackoverflow.com/a/71169165
    await new Promise(resolve => {
      playerPromiseResolve = resolve
      loadPlayerDelay = setTimeout(resolve, currentAmpLoadDelayMs)
      currentAmpLoadDelayMs += AMP_LOAD_DELAY_BETWEEN_MS
    })
    this.player = amp(this.videoRef.current, settings)

    this.player.addEventListener('ended', () => onEnded(dataTestId))
    this.player.addEventListener('pause', () => onStopped(dataTestId))
    this.player.addEventListener('play', () => onPlay(dataTestId))
    this.player.addEventListener('sourceset', () => onSourceSet())

    this.player.poster(poster)
    if (this.state.videoUrl || videoUrl) {
      this.player.src({ src: this.state.videoUrl || videoUrl }, tracks)
    }
  }

  render() {
    return (
      <Wrapper className="amsWrapper">
        <div
          className="azuremediaplayer amp-flush-skin amp-big-play-centered"
          ref={this.videoRef}
        />
      </Wrapper>
    )
  }
}
